export default __webpack_public_path__ + "static/media/prometheus.abe4b807.svg";